import React, { useState } from "react";
import LandingHeader from "../components/layout/LandingHeader";
import LandingFooter from "../components/layout/LandingFooter";
import WhatsAppButton from "../components/common/WhatsAppButton";
import { Button, Input, Switch } from "../components/ui";
import {
  Mail,
  MessageCircle,
  Bell,
  QrCode,
  Shield,
  Clock,
  Wallet,
  Users,
  Headphones,
  Smartphone,
  ArrowRight,
} from "lucide-react";

function ComoFunciona() {
  const [switches, setSwitches] = useState({
    confirmacao: true,
    lembrete: true,
    posEvento: true,
  });

  const handleSwitchChange = (key) => {
    setSwitches((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const benefits = [
    { title: "100% SEGURO", text: "Dados protegidos com criptografia e tecnologia de ponta.", icon: Shield },
    { title: "ECONOMIZE TEMPO", text: "Automação total de processos que elimina as tarefas manuais.", icon: Clock },
    { title: "MAIS RECEITA", text: "Recursos inteligentes e cupons que maximizam as suas inscrições.", icon: Wallet },
    { title: "MELHOR EXPERIÊNCIA", text: "Atletas engajados e satisfeitos do início ao pós-evento.", icon: Users },
    { title: "SUPORTE HUMANO", text: "Nossa equipe de especialistas estará sempre disponível com você.", icon: Headphones },
    { title: "ACESSO EM QUALQUER LUGAR", text: "Plataforma 100% online e responsiva em computadores e celulares.", icon: Smartphone },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-urb-dark text-slate-100 selection:bg-urb-primary selection:text-black">
      <LandingHeader />

      <main className="flex-1 py-12 px-4 md:px-8">
        <section className="max-w-7xl mx-auto flex flex-col gap-6">
          {/* Hero Section */}
          <div className="flex flex-col gap-2 mb-8">
            <span className="font-semibold text-xs sm:text-sm tracking-wider uppercase text-urb-primary">
              SIMPLES, RÁPIDO E COMPLETO
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black m-0 leading-tight">
              COMO FUNCIONA A <span className="text-urb-primary drop-shadow-[0_0_12px_rgba(138,230,0,0.3)]">URB RACE</span>
            </h1>
            <p className="text-slate-400 text-base sm:text-lg m-0 max-w-2xl leading-relaxed">
              Criamos uma jornada completa para que você organize eventos incríveis e proporcione a melhor experiência para os atletas.
            </p>
          </div>

          {/* Steps Timeline Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 py-4">
            {/* Step 1 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                1
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">CRIE SEU EVENTO</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Cadastre sua corrida em poucos minutos e personalize cada detalhe.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-2.5">
                  <span className="font-medium text-white text-xs block">Novo evento</span>
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-400">Nome do evento</label>
                    <Input value="URB Night Run" readOnly className="py-1 px-2.5 text-xs bg-slate-900 border-slate-700 h-8" />
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-[11px]">
                    <div className="flex flex-col gap-1">
                      <label className="text-[10px] text-slate-400">Data</label>
                      <span className="text-white border border-slate-800 bg-slate-900/60 p-1.5 rounded-lg block">25/05/2026</span>
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="text-[10px] text-slate-400">Local</label>
                      <span className="text-white border border-slate-800 bg-slate-900/60 p-1.5 rounded-lg block">Macapá, AP</span>
                    </div>
                  </div>
                  <Button variant="primary" size="sm" className="w-full text-xs font-bold mt-1 uppercase">
                    CRIAR EVENTO
                  </Button>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                2
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">CONFIGURE E VENDA</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Crie lotes, defina valores e abra as inscrições para os atletas.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-3">
                  <span className="font-medium text-white text-xs block">Lotes de Inscrição</span>
                  <div className="flex flex-col gap-2 text-xs">
                    <div className="flex justify-between items-center text-slate-300 border-b border-slate-800/60 pb-1.5">
                      <span>1º Lote Promo</span>
                      <span className="font-bold text-urb-primary">R$ 79,90</span>
                    </div>
                    <div className="flex justify-between items-center text-slate-300 border-b border-slate-800/60 pb-1.5">
                      <span>2º Lote</span>
                      <span className="font-bold text-white">R$ 99,90</span>
                    </div>
                    <div className="flex justify-between items-center text-slate-500">
                      <span>3º Lote</span>
                      <span className="text-[10px] uppercase font-semibold bg-slate-800 px-2 py-0.5 rounded text-slate-400">Em breve</span>
                    </div>
                  </div>
                  <Button variant="primary" size="sm" className="w-full text-xs font-bold mt-1 uppercase">
                    PUBLICAR EVENTO
                  </Button>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                3
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">RECEBA PAGAMENTOS</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Pagamentos online com segurança e repasse automático na sua conta.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-2.5">
                  <span className="font-medium text-white text-xs block">Resumo financeiro</span>
                  <div className="flex flex-col gap-1.5 text-xs">
                    <div className="flex justify-between">
                      <span className="text-slate-400">Arrecadado:</span>
                      <span className="font-medium text-white">R$ 98.670,00</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-400">Taxas:</span>
                      <span className="text-red-400 font-medium">- R$ 6.123,20</span>
                    </div>
                    <div className="flex justify-between border-t border-slate-800 pt-1.5 mt-0.5">
                      <span className="text-white font-bold">Líquido:</span>
                      <span className="font-bold text-urb-primary">R$ 92.546,80</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between bg-emerald-950/40 border border-emerald-800/40 px-3 py-1.5 rounded-lg mt-1 text-xs">
                    <span className="text-urb-primary font-bold text-[11px]">PIX</span>
                    <span className="text-emerald-400 font-bold text-[11px] tracking-wider">AGENDADO</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                4
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">COMUNICAÇÃO</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Comunique atletas automaticamente por e-mail e WhatsApp.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-2.5">
                  <span className="font-medium text-white text-xs block">Mensagens</span>
                  <div className="flex flex-col gap-2.5 text-xs">
                    <div className="flex items-center justify-between">
                      <span className="text-slate-300">Confirmação</span>
                      <Switch checked={switches.confirmacao} onChange={() => handleSwitchChange("confirmacao")} />
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-slate-300">Lembrete pré-evento</span>
                      <Switch checked={switches.lembrete} onChange={() => handleSwitchChange("lembrete")} />
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-slate-300">Pós-evento</span>
                      <Switch checked={switches.posEvento} onChange={() => handleSwitchChange("posEvento")} />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-center mt-2 pt-2 border-t border-slate-800/60 text-slate-400">
                    <Mail className="w-4 h-4 hover:text-white transition-colors" />
                    <MessageCircle className="w-4 h-4 text-emerald-400 hover:text-emerald-300 transition-colors" />
                    <Bell className="w-4 h-4 text-amber-400 hover:text-amber-300 transition-colors" />
                  </div>
                </div>
              </div>
            </div>

            {/* Step 5 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                5
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">FAÇA O CHECK-IN</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Check-in inteligente com QR Code. Rápido, offline e sem filas.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-2.5">
                  <span className="font-medium text-white text-xs block">Check-in em andamento</span>
                  <div className="flex items-center gap-2.5">
                    <div className="w-7 h-7 rounded-full bg-urb-primary flex items-center justify-center text-xs font-bold text-black shrink-0">
                      JS
                    </div>
                    <div className="flex flex-col">
                      <span className="text-white font-bold text-xs">João da Silva</span>
                      <span className="text-slate-400 text-[10px]">10K - Masculino</span>
                    </div>
                  </div>
                  <div className="flex justify-center my-1">
                    <div className="p-2.5 border border-urb-primary/60 bg-black rounded-xl">
                      <QrCode className="w-10 h-10 text-urb-primary" />
                    </div>
                  </div>
                  <div className="text-center font-bold text-urb-primary bg-emerald-950/50 border border-emerald-800/40 py-1 rounded-lg text-[10px] tracking-wider uppercase">
                    CHECK-IN REALIZADO!
                  </div>
                </div>
              </div>
            </div>

            {/* Step 6 */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center font-black text-urb-primary text-sm">
                6
              </div>
              <div>
                <span className="font-bold text-white text-base block mb-1">ACOMPANHE</span>
                <p className="text-xs text-slate-400 mb-5 leading-relaxed">
                  Resultados em tempo real e relatórios na palma da mão.
                </p>
                <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3.5 flex flex-col gap-2.5">
                  <span className="font-medium text-white text-xs block">Dashboard do evento</span>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div className="p-2 rounded-lg bg-slate-900 border border-slate-800">
                      <span className="text-slate-400 block text-[10px]">Inscritos</span>
                      <span className="font-bold text-white text-sm">2.431</span>
                    </div>
                    <div className="p-2 rounded-lg bg-slate-900 border border-slate-800">
                      <span className="text-slate-400 block text-[10px]">Receita</span>
                      <span className="font-bold text-white text-sm">R$ 98.670</span>
                    </div>
                  </div>
                  <div className="h-8 flex items-end justify-between px-2 opacity-80 mt-1 gap-1.5">
                    <div className="flex-1 bg-urb-primary rounded-t" style={{ height: "40%" }} />
                    <div className="flex-1 bg-urb-primary rounded-t" style={{ height: "60%" }} />
                    <div className="flex-1 bg-urb-primary rounded-t" style={{ height: "75%" }} />
                    <div className="flex-1 bg-urb-primary rounded-t" style={{ height: "95%" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16 px-4 md:px-8 border-y border-urb-border my-12 bg-slate-950/40">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-white">TUDO EM UM SÓ LUGAR</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {benefits.map((benefit, idx) => {
                const Icon = benefit.icon;
                return (
                  <div key={idx} className="p-4 rounded-xl bg-urb-card/40 border border-urb-border/60 hover:border-urb-primary/40 transition-colors">
                    <div className="flex items-start gap-4">
                      <div className="w-11 h-11 rounded-xl bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center shrink-0">
                        <Icon className="w-5 h-5 text-urb-primary" />
                      </div>
                      <div className="flex flex-col gap-1">
                        <span className="font-bold text-white text-sm">{benefit.title}</span>
                        <p className="text-xs text-slate-400 m-0 leading-relaxed max-w-[260px]">
                          {benefit.text}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-8 px-4 md:px-8 max-w-5xl mx-auto mb-10">
          <div className="bg-gradient-to-r from-slate-900 via-urb-card to-slate-900 border border-urb-border rounded-3xl p-6 sm:p-10 flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl relative overflow-hidden">
            <div className="flex flex-col gap-3 relative z-10 text-center md:text-left">
              <h2 className="text-2xl sm:text-3xl font-black text-white leading-tight">
                PRONTO PARA LEVAR SUA CORRIDA <br />
                <span className="text-urb-primary">AO PRÓXIMO NÍVEL?</span>
              </h2>
              <p className="m-0 text-slate-300 text-sm max-w-lg leading-relaxed">
                Junte-se a centenas de organizadores que já transformaram seus eventos com a URB RACE.
              </p>
            </div>
            <div className="relative z-10 w-full md:w-auto">
              <Button
                variant="primary"
                size="lg"
                className="w-full md:w-auto font-black text-sm uppercase px-8 py-3.5 tracking-wider shadow-lg flex items-center justify-center gap-2"
              >
                CRIAR MEU EVENTO AGORA
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          </div>
        </section>
      </main>

      <LandingFooter />

      {/* Botão Flutuante do WhatsApp */}
      <WhatsAppButton />
    </div>
  );
}

export default ComoFunciona;
